import { request } from "../lib/requestHelper";

export const fetchAllCraftsService = async (search = '') => {
    const url = search ? `api/fetch-all-crafts?search=${encodeURIComponent(search)}` : "api/fetch-all-crafts";
    return await request(url, { method: "GET" });
};

export const fetchFeaturedCraftsService = async () => {
    return await request("api/fetch-featured-crafts", { method: "GET" });
};

export const fetchCategorizedCraftsService = async () => {
    return await request("api/fetch-categorized-crafts", { method: "GET" });
};